import { useSelector, shallowEqual } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { AccountFinancesHistory } from 'app/common/components/Finances/FinancesHistory'
import getRegAvailable from 'app/selectors/getRegAvailable'
import config from 'app/config'

type Props = {
  params: {
    date: string
  }
}

const FinancesPage = ({ params: { date } }: Props) => {
  const { t } = useTranslation('finances')
  const { timezone = config.defaultTimezone } = useSelector(
    (state: any) => state.user,
    shallowEqual,
  )
  const regAvailable = useSelector(getRegAvailable)
  const { company } = useSelector((state: any) => state.dealer, shallowEqual)

  const headerCommentary = !regAvailable
    ? t('sub_header_info_long', { company })
    : t('sub_header_info', { company })

  return (
    <AccountFinancesHistory date={date} timezone={timezone} headerCommentary={headerCommentary} />
  )
}

export default FinancesPage
